import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installDebugDiagnostics } from "./lib/debugDiagnostics";
import { isNonProductionDebugEnvironment } from "./lib/debugClipboard";
import { initializeAmplitudeAnalytics } from "./lib/amplitudeAnalytics";
import { initSentry } from "./lib/sentry";
import { scrubPublicTokenUrlBeforeInit } from "./lib/publicTokenSession";

if (isNonProductionDebugEnvironment()) {
  installDebugDiagnostics();
}

// ENT-3137 (Codex round-14 on #2456): strip the public-token bearer secret from
// the address bar BEFORE Sentry initialises. Sentry Session Replay records the
// initial window.location and its recording envelopes bypass beforeSend, so this
// must run before initSentry() (the token is stashed to sessionStorage first,
// where the TeleLens pages recover it).
scrubPublicTokenUrlBeforeInit();

initSentry();
void initializeAmplitudeAnalytics();

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <App />
    </Sentry.ErrorBoundary>,
  );
}
